import React from 'react';

interface ClockHistoryIconProps {
  size?: number;
  color?: string;
}

export const ClockHistoryIcon: React.FC<ClockHistoryIconProps> = ({ 
  size = 20, 
  color = '#6e6e6e' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 20 20"
    >
      <path 
        fill={color} 
        d="M10 1.875a8.125 8.125 0 1 1 0 16.25 8.125 8.125 0 0 1 0-16.25m0 2.5q-1.281 0-2.43.547a5.46 5.46 0 0 0-1.945 1.547V5h-1.25v3.75h3.75V7.5H6.406a4.64 4.64 0 0 1 1.578-1.375 4.2 4.2 0 0 1 2.016-.5q1.83 0 3.102 1.273T14.375 10q0 1.83-1.273 3.102-1.274 1.272-3.102 1.273a4.24 4.24 0 0 1-2.867-1.062 4.18 4.18 0 0 1-1.445-2.688H4.406q.236 2.14 1.836 3.57T10 15.625q1.173 0 2.195-.445a5.8 5.8 0 0 0 1.782-1.203 5.7 5.7 0 0 0 1.203-1.782A5.5 5.5 0 0 0 15.625 10q0-1.17-.445-2.195a5.7 5.7 0 0 0-1.203-1.782 5.7 5.7 0 0 0-1.782-1.203A5.4 5.4 0 0 0 10 4.375m-.625 2.5v3.375l2.375 2.375.875-.875-2-2V6.875z"
      />
    </svg>
  );
};

